import React, { Component } from 'react'
import './contact.css'

export class contact extends Component {
    render() {
        return (
            <div id="contact-con">
            <div id="contact-1-con">
                <div className="contact-text-box">
                <div className="contact-text-box-1">
                <h2 id="contact-title">Contact Us</h2>
                <p className="contact-text">Thank you for your interest in our Orthotics or Personal Protective Equipment Safety products and services. If you have an issue or question regarding our products or purchasing please reach out via email or phone.</p>
                <p className="contact-text">(877) 375-8772</p>
                <p className="contact-text">New York, USA</p>
                </div></div>

                <div className="contact-text-box">
                <div id="open-time">
                <h2 id="open-title">Hours</h2>    
                <p className="open-text">Mon - Fri: 10am - 9pm</p>
                <p className="open-text">Sat: 11am - 9pm</p>
                <p className="open-text">Sun: 11am - 5pm</p>    
                </div>
                </div>
            </div>


                <div id="bulk-con">
                <h2 className="bulk-title">Bulk Order Form</h2>
                <p className="bulk-text">For bulk orders please fill out the form below and we’ll be intouch shortly.</p>
                <div className="bulk-form-con">
                
                <input className="bulk-input" type="text" defaultValue="Full Name"/>

     <div id="options-con">           
    <select className="options" id="bulk-products" name="Products" value="Products">
    <option value="Products">Products</option>
    <option value="saab">Face Mask</option>
    <option value="fiat">Face Shield</option>
    <option value="audi">Mask Extension</option>
    <option value="audi">Cam Walker</option>
    <option value="audi">Knee Brace</option>
    <option value="audi">Ankle Brace</option>
    </select>

    <select className="options" id="bulk-quantity" name="quantity" value="quantity">
    <option value="Products">1</option>
    <option value="saab">2</option>
    <option value="fiat">3</option>
    <option value="audi">4</option>
    <option value="audi">5</option>
    <option value="audi">6</option>
    <option value="audi">7</option>
    </select>
            </div>
    <input className="bulk-input" type="Email" defaultValue="Email Address"/>
    <textarea className="bulk-area">Message</textarea>
    <button className="bulk-btn">Submit</button>
                </div>
                
    </div>


                <div id="live-con">
                <h2 className="bulk-title">Book A Live Video Demo</h2>
                <p className="bulk-text">If you want learn more about our products book a live video demo below!</p>
                <div className="bulk-form-con">
                
                <input id="live-1" className="bulk-input" type="text" defaultValue="Full Name"/>
                <input id="live-2"  className="bulk-input" type="Email" defaultValue="Email Address"/>

                <textarea  className="bulk-area" id="ta" >Message</textarea>
                <button className="bulk-btn">Submit</button>
                </div>               


                </div>



            </div>
        )
    }
}

export default contact
